export const normalizeHeaderKey = (value) => {
  const s = String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  return s;
};

export const buildAyudasIsaHeaderMapping = (headerTexts) => {
  const mapping = {};
  const candidates = [
    { includes: 'consecutivo actividad', key: 'actividad_consecutivo' },
    { includes: 'grupo categoria', key: 'grupo' },
    { includes: 'subgrupo dependiente', key: 'subgrupo' },
    { includes: 'título de la ayuda', key: 'titulo' },
    { includes: 'titulo de la ayuda', key: 'titulo' },
    { includes: 'descripción general', key: 'desc_richtext' },
    { includes: 'descripcion general', key: 'desc_richtext' },
    { includes: 'condición y criterio de aplicación', key: 'cond_richtext' },
    { includes: 'condicion y criterio de aplicacion', key: 'cond_richtext' },
    { includes: 'puntos clave de la intervención', key: 'puntos_richtext' },
    { includes: 'puntos clave de la intervencion', key: 'puntos_richtext' },
    { includes: 'información de la intervención', key: 'info_interv_richtext' },
    { includes: 'informacion de la intervencion', key: 'info_interv_richtext' },
    { includes: 'frecuencia y periodicidad', key: 'freq_richtext' },
    { includes: 'excepciones', key: 'excep_richtext' },
    { includes: 'fuente', key: 'source_rich' },
    { includes: 'etiquetas / keywords', key: 'tags' },
    { includes: 'etiquetas', key: 'tags' },
  ];

  (headerTexts || []).forEach((raw, idx) => {
    const parts = String(raw || '').split('-').map((p) => p.trim()).filter(Boolean);
    const rightSide = normalizeHeaderKey(parts.length > 1 ? parts[parts.length - 1] : raw);

    const match = candidates.find((c) => rightSide.includes(normalizeHeaderKey(c.includes)));
    if (!match) return;
    mapping[idx] = match.key;
  });

  return mapping;
};

export const htmlToTags = (cellEl) => {
  if (!cellEl) return [];
  const li = Array.from(cellEl.querySelectorAll('li'))
    .map((n) => (n.textContent || '').trim())
    .filter(Boolean);
  if (li.length > 0) return Array.from(new Set(li));

  const text = (cellEl.textContent || '').replace(/\s+/g, ' ').trim();
  if (!text) return [];
  const rawParts = text.split(/\s*\/\s*|[,;|]/g).map((s) => s.trim()).filter(Boolean);
  if (rawParts.length > 1) return Array.from(new Set(rawParts));
  return [text];
};

export const extractAyudasIsaRowsFromHtml = (html) => {
  const doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
  const tables = Array.from(doc.querySelectorAll('table'));
  if (tables.length === 0) return { rows: [], headerMapping: {}, headerTexts: [] };

  const allRows = [];
  let pickedHeaderTexts = [];
  let pickedHeaderMapping = {};
  const seenKeys = new Set();

  const extractFromTable = (table) => {
    const tr = Array.from(table.querySelectorAll('tr'));
    if (tr.length < 2) return;

    const headerCells = Array.from(tr[0].querySelectorAll('th, td'));
    const headerTexts = headerCells.map((c) => (c.textContent || '').replace(/\s+/g, ' ').trim());
    const headerMapping = buildAyudasIsaHeaderMapping(headerTexts);
    if (Object.keys(headerMapping).length === 0) return;

    if (pickedHeaderTexts.length === 0) {
      pickedHeaderTexts = headerTexts;
      pickedHeaderMapping = headerMapping;
    }

    tr.slice(1).forEach((rowEl) => {
      const tds = Array.from(rowEl.querySelectorAll('td'));
      const row = {
        actividad_consecutivo: '',
        grupo: '',
        subgrupo: '',
        titulo: '',
        tags: [],
        desc_richtext: '',
        cond_richtext: '',
        puntos_richtext: '',
        info_interv_richtext: '',
        freq_richtext: '',
        excep_richtext: '',
        source_rich: '',
      };

      Object.entries(headerMapping).forEach(([idxStr, key]) => {
        const idx = Number(idxStr);
        const cell = tds[idx];
        if (!cell) return;

        if (key === 'tags') {
          row.tags = htmlToTags(cell);
          return;
        }

        const isRichText = key.endsWith('_richtext');
        const content = isRichText ? (cell.innerHTML || '').trim() : (cell.textContent || '').trim();

        if (key === 'actividad_consecutivo' || key === 'grupo' || key === 'subgrupo') {
          row[key] = content.replace(/\s+/g, ' ').trim();
        } else {
          row[key] = content;
        }
      });

      if (!row.actividad_consecutivo && !row.grupo && !row.subgrupo && !row.titulo) return;

      const uniqueKey = `${row.actividad_consecutivo}__${row.grupo}__${row.subgrupo}`;
      if (row.actividad_consecutivo && row.grupo && row.subgrupo) {
        if (seenKeys.has(uniqueKey)) return;
        seenKeys.add(uniqueKey);
      }

      allRows.push(row);
    });
  };

  tables.forEach(extractFromTable);

  return { rows: allRows, headerMapping: pickedHeaderMapping, headerTexts: pickedHeaderTexts };
};
